/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loose_Bold_Sloth_CreateInputs */

const es_loose_bold_sloth_create = /** @type {(inputs: Loose_Bold_Sloth_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejanos tu email`)
};

const gl_loose_bold_sloth_create = /** @type {(inputs: Loose_Bold_Sloth_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déixanos o teu correo electrónico`)
};

const en_loose_bold_sloth_create = /** @type {(inputs: Loose_Bold_Sloth_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave us your email`)
};

/**
* | output |
* | --- |
* | "Leave us your email" |
*
* @param {Loose_Bold_Sloth_CreateInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const loose_bold_sloth_create = /** @type {((inputs?: Loose_Bold_Sloth_CreateInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loose_Bold_Sloth_CreateInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_loose_bold_sloth_create(inputs)
	if (locale === "en") return en_loose_bold_sloth_create(inputs)
	return es_loose_bold_sloth_create(inputs)
});